import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=96b3bcc4"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"
import style0 from "./audit.vue?vue&type=style&index=0&id=96b3bcc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports